/**
 * BattleStepType - Type de step pour les combats D6
 * Déclare les extraFields pour ce StepType
 */

import {StepType} from '../../types/StepType';
import {ExtraFieldType} from '../../types/ExtraFieldType';
import GameRegistry from '../../GameRegistry';

export class BattleStepType implements StepType {
  typeName = 'D6_STEP_BATTLE';

  /**
   * Retourne les types d'extraFields déclarés pour ce StepType
   * Agnostique : le GameStateHelper utilise cette méthode pour savoir quels extraFields initialiser
   * Les types sont enregistrés dans le GameRegistry par D6System
   */
  getStepExtraFieldTypes(): ExtraFieldType[] {
    // Récupérer les types _MONSTER depuis le GameRegistry (agnostique)
    return [
      GameRegistry.getExtraFieldType('D6_FORCE_MONSTER'),
      GameRegistry.getExtraFieldType('D6_PV_MONSTER'),
      GameRegistry.getExtraFieldType('D6_DAMAGE_MONSTER'),
    ].filter((type): type is ExtraFieldType => type !== undefined);
  }
}
